import { css } from 'styled-components';

// ** Utils
import { pxToRem } from 'utils/transform-px.utils';

const StyledLine = css`
  background-color: ${(props) => props.theme.color.main};
  position: absolute;
  left: 0;
  z-index: 1;
`;

export const StyledVerticalLine = css`
  ${StyledLine};
  width: ${pxToRem(5)};
  height: 100%;
  top: 0;
`;
export const StyledHorizontalLine = css`
  ${StyledLine};
  width: 100%;
  height: ${pxToRem(5)};
  bottom: 0;
`;

const StyledLineItem = css`
  background-color: ${(props) => props.theme.color.main};
  position: absolute;
  z-index: 1;
`;

export const StyledVerticalLineItem = css`
  ${StyledLineItem};
  left: 50%;
  width: ${pxToRem(4)};
  transform: translateX(-50%);
  ${(props) =>
    props.theme.media.down(
      'md',
      css`
        width: ${pxToRem(3)};
      `
    )}
`;

export const StyledHorizontalLineItem = css`
  ${StyledLineItem};
  top: 50%;
  height: ${pxToRem(4)};
  transform: translateY(-50%);
  ${(props) =>
    props.theme.media.down(
      'md',
      css`
        height: ${pxToRem(3)};
      `
    )}
`;
